import { render } from "./thankyou.vue?vue&type=template&id=339fa38c"
import script from "./thankyou.vue?vue&type=script&lang=js"
export * from "./thankyou.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__